module.exports = __webpack_public_path__ + "static/media/attack-number-7.0ba1808c.png";